import type { GameRoomState } from "@presidents/game-engine";
import React from "react";
import styled, { css } from "styled-components";
import { createPlayerMap } from "../utils/create-player-map";

export const Table = styled.table`
  text-align: left;
  width: 100%;
  border: 0;
  font-family: var(--altFontFamily);
  border-collapse: separate;
  border-spacing: 0 2px;
  margin: 8px auto;
`;
const THead = styled.thead`
  background-color: rgba(255, 255, 255, 0.1);
  font-size: 50%;
`;
export const TBody = styled.tbody`
  background-color: rgba(255, 255, 255, 0.1);
`;
const HeadCell = styled.th<{ align?: string }>`
  vertical-align: middle;
  text-align: ${(props) => props.align};
  padding: 4px;
`;
export const Cell = styled.td<{ align?: string }>`
  vertical-align: middle;
  text-align: ${(props) => props.align};
  padding: 4px;
`;
export const Row = styled.tr`
  color: #fff;
  padding-left: 8px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8), 0 0 4px rgba(0, 0, 0, 0.4);
  margin-bottom: 4px;

  & > ${Cell}:first-child {
    padding-left: 16px;
  }
  & > ${Cell}:last-child {
    padding-right: 16px;
  }
`;
const HasMoved = styled.span<{ moveDelta: number }>`
  display: inline-block;
  border: 5px solid transparent;
  ${(props) =>
    props.moveDelta < 0 &&
    css`
      margin-bottom: 2.5px;
      border-bottom-color: var(--success);
    `}
  ${(props) =>
    props.moveDelta > 0 &&
    css`
      margin-bottom: -2.5px;
      border-top-color: var(--asshole);
    `}
`;

const Position = styled.span`
  font-size: 80%;
`;
export const Name = styled.span`
  white-space: nowrap;
`;

const Score = styled.span`
  font-weight: bold;
  font-family: var(--fontFamily);
  font-variant-numeric: tabular-nums;
`;

const RankHistory = styled.div`
  font-size: 11px;
  text-align: right;
  margin-left: auto;
  white-space: nowrap;
`;

const RankHistoryItem = styled.span`
  display: inline-block;
  width: 16px;
  height: 14px;
  text-align: center;
  margin: 1px;
  background-color: rgba(255, 255, 255, 0.1);

  &[data-rank="P"] {
    background-color: var(--success);
  }
  &[data-rank="VP"] {
    background-color: var(--successMuted);
  }
  &[data-rank="VA"] {
    background-color: var(--assholeMuted);
  }
  &[data-rank="A"] {
    background-color: var(--asshole);
  }
`;

type Props = {
  players: GameRoomState["players"];
  leaderBoard: GameRoomState["leaderBoard"];
};
const LeaderBoard: React.FC<Props> = ({ leaderBoard, players }) => {
  const playersMap = createPlayerMap(players);
  const playerIds = Object.keys(playersMap);
  const filteredLeaderBoard = leaderBoard.filter((row) =>
    playerIds.includes(row.playerId)
  );
  return (
    <Table>
      <THead>
        <Row>
          <HeadCell align="right">Pos</HeadCell>
          <HeadCell></HeadCell>
          <HeadCell>Name</HeadCell>
          <HeadCell align="right">Pts</HeadCell>
          <HeadCell>Form</HeadCell>
        </Row>
      </THead>
      <TBody>
        {filteredLeaderBoard.map((data, position) => {
          return (
            <Row key={data.playerId}>
              <Cell align="right">
                <Position>{position + 1}</Position>
              </Cell>
              <Cell>
                {data.lastPosition !== -1 && (
                  <HasMoved moveDelta={position - data.lastPosition} />
                )}
              </Cell>
              <Cell>
                <Name>{playersMap[data.playerId]?.name}</Name>
              </Cell>
              <Cell align="right">
                <Score>{data.score}</Score>
              </Cell>
              <Cell>
                <RankHistory>
                  {data.rankHistory.slice(-5).map((v, histIdx) => (
                    <RankHistoryItem data-rank={v} key={histIdx}>
                      {v}
                    </RankHistoryItem>
                  ))}
                </RankHistory>
              </Cell>
            </Row>
          );
        })}
      </TBody>
    </Table>
  );
};

export default LeaderBoard;
